import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    numberPurchaseOrderList: () => {
        return HTTP.get('/lot/list_number_purchase_order', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    inventoryPurchaseOrderList: (id) => {
        return HTTP.get('/lot/inventory_purchase_order_getmat?po_code=' + id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addMaterialPurchaseOrder: (data) => {
        return HTTP.post('/lot/add_material_purchase_order',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    searchMaterial: () => {
        return HTTP.get('/lot/search_material', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addMaterialAddLotin: (data) => {
        return HTTP.post('/lot/add_material',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    }
}